import './record.scss'
import { useStore } from '@/store'
import { useLocal } from '@/i18n/LocalContext'
import CommonModal from '../CommonModal/CommonModal'
import { useEffect, useMemo, useRef, useState } from 'react'
import { getRecord } from '@/request'

export default function Record() {
  const { $t } = useLocal()
  const { state } = useStore()
  const recordOpen = state.modalData.recordOpen
  const zoneId = state.login.userInfo.zoneId
  const playerId = state.login.userInfo.playerId
  const awardTime = useMemo(() => {
    const timezoneMap = {
      1: '-5',
      2: '-5',
      3: '+9',
      5: '+8',
    }
    const timezone = timezoneMap[zoneId as Exclude<Role['zoneId'], 0>]
    return `${$t('领奖时间')}<br />(UTC${timezone})`
  }, [zoneId])
  const [recordList, setRecordList] = useState<RecordList>([])

  const pending = useRef(false)
  useEffect(() => {
    if (pending.current || !recordOpen || !playerId) return

    pending.current = true

    const _run = async () => {
      const list = await getRecord(playerId)
      setRecordList(list)
      pending.current = false
    }
    _run()
  }, [recordOpen, playerId])

  return (
    <CommonModal open={recordOpen} title={$t('获奖记录')} type="record">
      {[
        <div key="1" className="record-table">
          <ul className="record-table-header">
            <li
              className="record-table-header-item"
              dangerouslySetInnerHTML={{ __html: awardTime }}
            ></li>
            <li className="record-table-header-item">{$t('奖励')}</li>
            <li className="record-table-header-item">{$t('途径')}</li>
          </ul>
          <div className="record-table-body">
            <div className="record-table-body__inner">
              {recordList.map((record, index) => (
                <ul className="record-table-row" key={index}>
                  <li className="record-table-cell">
                    <div
                      className="record-table-item"
                      dangerouslySetInnerHTML={{ __html: record.createdAt }}
                    ></div>
                  </li>
                  <li className="record-table-cell">
                    <div
                      className="record-table-item record-table-item--break"
                      dangerouslySetInnerHTML={{ __html: record.rewards }}
                    ></div>
                  </li>
                  <li className="record-table-cell">
                    <div className="record-table-item record-table-item--break">
                      <span>{record.alias}</span>
                    </div>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </div>,
      ]}
    </CommonModal>
  )
}
